import { routes } from "../routes";
import { Platform } from "../types";
import { useNavigate } from "../utils";

const platformNames = {
  [Platform.ios]: "iPad",
  [Platform.android]: "Android",
};

export const Landing = () => {
  const navigate = useNavigate();
  return (
    <div className="landing">
      <header className="header">
        <img
          src="/images/logo.png"
          style={{ width: 180, height: 34 }}
          alt="orzo class logo"
        />
        <span style={{ textAlign: "center" }}>
          반갑습니다. 로그인 하기 전,
          <br />
          사용하실 태블릿의 OS를 선택해주세요.
        </span>
      </header>
      <div style={{ marginTop: 80 }} className="buttons">
        <div
          style={{
            backgroundColor: "#fff4f4",
            padding: "3px 8px 3px 8px",
            borderRadius: 4,
            alignSelf: "center",
          }}
        >
          <span style={{ fontSize: 12, fontWeight: 500, color: "#FF6666" }}>
            서로 다른 OS 간의 계정은 호환되지 않습니다.
          </span>
        </div>
        <button style={{ height: 44 }} onClick={() => navigate(routes.ios)}>
          <img
            src="/images/apple.png"
            style={{ width: 16, height: 16 }}
            alt="apple logo"
          />
          <span style={{ fontSize: 16, marginLeft: 8 }}>
            {platformNames[Platform.ios]}
          </span>
        </button>
        <button style={{ height: 44 }} onClick={() => navigate(routes.android)}>
          <img
            src="/images/android.png"
            style={{ width: 16, height: 16 }}
            alt="android logo"
          />
          <span style={{ fontSize: 16, marginLeft: 8 }}>
            {platformNames[Platform.android]}
          </span>
        </button>
      </div>
    </div>
  );
};
